import { Component, OnInit } from '@angular/core';
import { PreferencesService } from '../../preferences.service';
import { NotificationsService } from 'angular2-notifications';
import { AlertVM } from '../../../../../app/entities/alerts/alerts';
import { MatDialog } from '@angular/material/dialog';
import { FleetReportConfigurationComponent } from '../../../../../app/modules/dashboard/fleet-report-configuration/fleet-report-configuration.component';
import { ConfigType } from '../../../../../app/shared/enums/allEnums';

@Component({
  selector: 'app-report-alert',
  templateUrl: './report-alert.component.html',
  styleUrls: ['./report-alert.component.scss']
})
export class ReportAlertComponent implements OnInit {

  constructor( private readonly _pref: PreferencesService,
          private readonly _notify: NotificationsService, private _dialog: MatDialog) { }

  ngOnInit(): void {
    this.GetAlertsAsync();
  }
AlertVM:AlertVM;
 GetAlertsAsync() {
    this._pref.GetAlertsAsync(2).subscribe(res => {
         this.AlertVM = res;
         console.log(this.AlertVM);
    }, error => {
        console.error(error);     
            this._notify.error('Error', 'Unable to load alerts. Please contact TrackTreads support. ');
     });
 }

 onToggleChange(alert: any) {
  alert.isEnabled = !alert.IsEnabled;
  this._pref.updateAlertStatus(alert.AlertId, alert.IsEnabled)
    .subscribe({
      next: () => {
        alert.isEnabled = !alert.isEnabled;
         this._notify.success('Saved', 'Alert status updated.');
      },
      error: (err) => {
        console.error(err);
        this._notify.error('Error', 'Unable to update alert.');
      }
    });
}
 openFleetReport(alert) {
 this._dialog.open(FleetReportConfigurationComponent, {
  panelClass: 'removeModalOverflow',
  maxHeight: '960px',
  autoFocus: false,
  disableClose: true,
  data: {
     RequestFromFlag: ConfigType.Alert ,//,
     alertId: alert.AlertId
    }
});
}
}
